import BaseInputControl from "./BaseInputControl";
import type { HandleInputChange } from "./types";

type MonthInputProps = {
    name: string;
    value?: string | number;
    placeholder?: string;
    disabled?: boolean;
    onChange: HandleInputChange;
};

const MonthInput = ({ name, value, placeholder, disabled = false, onChange }: MonthInputProps) => {
    return (
        <BaseInputControl
            type="month"
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            disabled={disabled}
        />
    );
};

export default MonthInput;
